export enum ApiSearchUrls {
  SearchCourses = '/api/v1.0/catalog/search/courses',
  SearchTalents = '/api/v1.0/catalog/search/talents',
  SearchProfileClasses = '/api/v1.0/catalog/search/profilclasses',
  TalentGroupCourse = '/api/v1.0/catalog/search/talentgroupcourse',
}
